var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"#F0F0F1 ",staticStyle:{"width":"100%","height":"100%"}},[_c('NavigationDrawer'),_c('NavMenu'),_c('Container'),_c('BottomNavMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }